<template>
  <div id="talk" v-if="service && service.active" :data-step="step" :class="{viewAvailableTime: setting && setting.viewAvailableTime}">
    <span v-if="setting && setting.viewAvailableTime" class="btnInfo notranslate" @click.stop="setAvailable(true)"><i>&#128340;</i> {{locale.available_time}}</span>
    <div class="chat">
      <div class="head">
        <button v-if="step === 2" type="button" class="btnBack" @click.stop="goStep(1)"></button>
        <span>{{talkTitle ? talkTitle[lang] : site.title[lang]}}</span>
        <button type="button" class="btnClose" @click.stop="close"></button>
      </div>
      <div v-if="step === 1" id="enteranceBody" class="body">
        <Message
          :locale="locale"
          :lang="lang"
          :user="user"
          :enterance="true"
          :messageList="enterance"
          @create="talkCreate"
          @updateUserinfo="updateChannel"
          @getMessage="getMessageCard" />
      </div>
      <div v-if="step === 2" id="talkBody" class="body" @scroll.passive="scrollBody">
        <div ref="bodyInner" id="bodyInner">
          <Message
            :locale="locale"
            :lang="lang"
            :user="user"
            :messageList="welcome"
            @create="talkCreate"
            @updateUserinfo="updateChannel"
            @getMessage="getMessageCard" />
          <Card v-for="(msg, index) in card"
            :key="index"
            :locale="locale"
            :lang="lang"
            :cid="cid"
            :sender="setting
              ? setting.senderIcon === '3'
                ? setting.senderIconThumb
                : setting.senderIcon
              : '0'"
            :message="msg"
            :data-msgId="msg.msgId"
            :isTranslate="setting && setting.disabledTranslate !== true"
            @reSend="reSend"
            @delDisconnect="delDisconnect" />
          <div v-if="sending" class="loading sending">
            <img src="@/assets/img/ico_send.png" alt="">
            <div class="dot"></div>
          </div>
          <div v-if="uploading" class="loading sending">
            <img src="@/assets/img/ico_send_video.png" alt="">
            <div class="dot"></div>
          </div>
          <Message
            v-if="isDisabled"
            :locale="locale"
            :lang="lang"
            :user="user"
            :messageList="missed"
            @create="talkCreate"
            @updateUserinfo="updateChannel"
            @getMessage="getMessageCard" />
        </div>
      </div>
      <div v-if="step === 2" class="action" :class="{isDisabled: isDisabled, isTablet: isTablet}">
        <div v-if="toast" class="toast" @click.stop="toastScroll">{{locale.talk_new_message}} ↓</div>
        <div v-if="attachImg" class="attachImg">
          <div class="img"
            :class="{sending: sendingImg}"
            @click.stop="delImg">
            <span v-if="sendingImg" class="dot"></span>
            <img :src="attachImg.base64" alt="">
          </div>
        </div>
        <div v-if="!isTablet" class="uploadImg">
          <input
            type="file"
            id="talk_upload_img"
            :disabled="isDisabled"
            @change="setImage($event)">
          <label for="talk_upload_img"></label>
        </div>
        <textarea class="input"
          ref="contentInput"
          rows="3"
          :disabled="isDisabled"
          :placeholder="locale.placeholder_talk_chat"
          v-model="content"
          @keydown="onKeydown"
          @keyup="onKeyup">
        </textarea>
        <button v-if="!isDisabled" type="button" class="btnSend" @click.stop="send"></button>
      </div>
    </div>
    <AvailableTable
      v-if="availableTable && service && service.available"
      :locale="locale"
      :table="service.available"
      @close="setAvailable(false)" />
  </div>
</template>

<script>
import ls from 'localstorage-slim'
import { uniqueNamesGenerator, colors, animals, NumberDictionary } from 'unique-names-generator'
import moment from 'moment-timezone'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import COMMON from '@/common/common'
import Card from '@/components/Talk/Card'
import Message from '@/components/Talk/Message'
import AvailableTable from '@/components/Util/AvailableTable'

export default {
  props: [
    'locale',
    'lang'
  ],
  components: {
    Card,
    Message,
    AvailableTable
  },
  computed: {
    site () {
      return this.$store.state.common.setting
    },
    siteinfo () {
      return this.$store.state.authentication
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    gotMessage () {
      return this.$store.getters['talk/gotMessage']
    },
    isDisabled () {
      return this.service && !this.service.now
    },
    updateSetting () {
      return this.$store.getters['talk/updateSetting']
    },
    getAvailableDay () {
      return this.$store.getters['util/getAvailableDay']
    },
    hasChannel () {
      return this.$store.getters['talkChannel']
    },
    isTablet () {
      return this.$store.getters['isTablet']
    }
  },
  watch: {
    '$route' (to, from, next) {
      if (to.name !== from.name) {
        this.$store.commit('talk', false)
      }
    },
    onLine (e) {
      if (!e) {
        alert(this.locale.message_connection)
        this.sending = false
        this.uploading = false
      }
    },
    isBackground (isBackground) {
      /**
       * 백그라운드 상태에서 읽음표시를 하는 api 호출은 하지 않고
       * 포그라운드 상태가 되었을 때 모든 id를 읽음표시한다
       */
      if (!isBackground && this.cid) {
        const ids = this.card.filter(x => !x.readByUser).map(x => x.msgId)
        this.readByUser(this.cid, ids)
      }
    },
    hasChannel (cid) { // 채널이 생기면 ws 연결
      if (cid) {
        this.getMessageList()
      }
    },
    gotMessage: {
      deep: true,
      handler (message) {
        this.setMessageList([message], false, true, message.from)
        if (message.type === 'video') {
          this.uploading = false
        }
      }
    },
    isDisabled (isDisabled) {
      if (isDisabled) {
        this.disabledMessage()
      } else {
        this.content = ''
      }
    },
    async updateSetting (isUpdate) {
      if (isUpdate) {
        await this.getServiceSetting()
        this.scrollBottom()
        if (this.service.active) {
          if (this.service.checkInOnly && !this.siteinfo.k) {
            // 체크인중인 고객만 사용 가능합니다.
            alert(this.locale.alert_talk_checkin_only)
            this.close()
            this.$destroy()
          }
        } else {
          // 지원하지 않는 기능입니다.
          alert(this.locale.alert_talk_not_service)
          this.close()
          this.$destroy()
          // this.$el.parentNode.removeChild(this.$el)
        }
      }
    }
  },
  beforeDestroy () {
    const cid = this.cid
    const hasCard = this.card.length > 0
    if (cid && hasCard) {
      const talkLastKey = `talkLatest_${cid}`
      const length = this.card.length
      const lastKey = this.card.find((x, i) => length === i + 1).createat
      localStorage.setItem(talkLastKey, lastKey) // 마지막 확인한 메시지 createat
    }
    this.close()
  },
  async mounted () {
    const siteinfo = this.siteinfo
    const key = `${siteinfo.site}_stayTalk`
    const cid = (siteinfo.space && siteinfo.k) || localStorage.getItem(key)
    const numberDictionary = NumberDictionary.generate({ min: 1, max: 999 })
    const invalidOta = !(siteinfo.space && siteinfo.k && siteinfo.otavalid !== 'false')
    // 온오프라인 상태를 위한 event listner
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
    function getMessageData (arr, cardList, tagList) {
      return arr ? arr.map(x => {
        const cardItem = x.type === 'card'
          ? { ...x, ...cardList.find(c => c.id === x.id), id: UNIQUE.mid() }
          : null
        const tagItem = x.type === 'tag'
          ? { ...x, tags: tagList, id: UNIQUE.mid() }
          : null
        return x.type === 'userInfo'
          ? x
          : x.type === 'card'
            ? cardItem
            : x.type === 'tag'
              ? tagItem
              : x
      }) : []
    }
    // 센터에서 저장한 서비스 관련 데이터 (활성/시간)
    await this.getServiceSetting()
    if (this.service.active) {
      this.checkDeviceSize()
      if (this.service.checkInOnly && invalidOta) {
        // 체크인중인 고객만 사용 가능합니다.
        alert(this.locale.alert_talk_checkin_only)
        this.close()
        this.$destroy()
        return null
      }
      document.addEventListener('visibilitychange', this.backgroundBrowser)
      window.addEventListener('resize', this.checkDeviceSize)
      // 모바일은 shift + enter가 없기 때문에 enter 자체를 prevent 해야하므로 디바이스 체크
      this.isMobile = COMMON.isMobile
      this.$store.commit('talk', true)
      this.$store.dispatch('talk/getSetting').then((res) => {
        if (res && res.setting) {
          const cardList = res.card && res.card.list
          const tagList = res.tag && res.tag.list
          this.talkTitle = res.setting.title
          this.enterance = getMessageData(res.setting.enterance, cardList, tagList) || []
          this.missed = getMessageData(res.setting.missed, cardList, tagList) || []
          this.welcome = getMessageData(res.setting.welcome, cardList, tagList) || []
          this.cardList = cardList
          this.tagList = tagList
          this.setting = res.setting
        }
      })
      // 대화채널 정보(userName, userPhone, ...) 처리
      await this.getChannel(cid).then((res) => {
        if (!res) {
          this.user.userName = uniqueNamesGenerator({
            dictionaries: [ colors, animals, numberDictionary ],
            separator: '_',
            style: 'upperCase'
          })
          // 없으면 새로운 cid + talk 생성
          this.$store.dispatch('talk/chatToken', {
            cid: cid || UNIQUE.mid(),
            ...siteinfo.k && { ota: siteinfo.k },
            ...this.user
          }).then((result) => {
            if (result) { // cid
              if (!result) {
                this.cid = null
                alert(this.locale.alert_system_error)
              } else {
                const key = `${siteinfo.site}_stayTalk`
                const receivedKey = `talkReceived_${cid}`
                this.$store.commit('talk', true)
                this.$store.commit('talk/received', 0)
                if (!siteinfo.k) {
                  localStorage.setItem(key, result)
                }
                localStorage.setItem(receivedKey, 0)
                setTimeout(() => {
                  this.cid = result
                  this.$store.commit('talk/setCid', result)
                }, 500)
              }
            } else {
              alert(this.locale.alert_system_error)
            }
          })
        }
      })
      if (cid) {
        const receivedKey = `talkReceived_${cid}`
        this.cid = cid
        this.goStep(2)
        // 1:1 대화내역 처리
        await this.getMessageList().then((res) => {
          // 대화내역이 없으면 첫화면으로
          if (res.length <= 0) {
            this.goStep(1)
          }
        })
        // 전송실패 메시지 처리(localStorage)
        this.getDisconnectMessage(cid)
        // 미확인 카운트 처리 (모두 읽음 표시)
        localStorage.setItem(receivedKey, 0)
        this.$store.commit('talk/received', 0)
        // 태그를 통한 자동응답
        this.getResponseMessage(cid)
      } else { // cid가 없음
        // this.user.userName = uniqueNamesGenerator({
        //   dictionaries: [ colors, animals, numberDictionary ],
        //   separator: '_',
        //   style: 'upperCase'
        // })
      }
    } else {
      // 지원하지 않는 기능입니다.
      alert(this.locale.alert_talk_not_service)
      this.close()
      this.$destroy()
      // this.$el.parentNode.removeChild(this.$el)
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.checkDeviceSize)
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },
  data () {
    return {
      onLine: navigator.onLine,
      isBackground: false,
      availableTable: false,
      step: 1, // 1: 태그/메시지, 2: 대화창
      wsStatus: null,
      wsClose: false,
      cid: null,
      talkTitle: null,
      user: {
        userName: '',
        userPhone: '',
        userEmail: ''
      },
      content: '',
      attachImg: null,
      message: null,
      card: [],
      lastEvaluatedKey: null,
      sending: false,
      sendingImg: false,
      uploading: false,
      toast: false,
      cardList: [],
      tagList: [],
      enterance: [],
      welcome: [],
      missed: [],
      disconnect: 0,
      shiftKey: false,
      isCreated: false,
      service: null,
      setting: null
    }
  },
  methods: {
    // (임시) 리셋
    resetAll () {
      if (window.confirm('대화정보를 초기화 하시겠습니까?')) {
        localStorage.clear()
        this.close()
        window.location.reload()
      }
    },
    setAvailable (isOpen) {
      this.availableTable = isOpen
    },
    onKeydown (e) {
      if (e.key === 'Shift' || e.key === 'Ctrl') {
        this.shiftKey = true
      }
      if (e.key === 'Enter' && !this.shiftKey && !this.isMobile) { // enter only (no shift+enter)
        e.preventDefault()
      }
    },
    onKeyup (e) {
      // resize textarea
      const contentInput = this.$refs.contentInput
      if (contentInput) {
        const offset = contentInput.offsetHeight - contentInput.clientHeight
        contentInput.style.height = `${contentInput.scrollHeight + offset}px`
      }
      if (e.key === 'Shift' || e.key === 'Ctrl') {
        this.shiftKey = false
      }
      if (e.key === 'Enter' && !this.shiftKey && !this.isMobile) { // enter only (no shift+enter)
        e.preventDefault()
        this.send()
      }
    },
    // 백그라운드일 때는 읽음표시를 하지 않기 위한 visibilityState 체크
    backgroundBrowser () {
      this.isBackground = document.visibilityState === 'hidden'
    },
    checkDeviceSize (e) {
      if (window.innerWidth < 768) {
        document.body.classList.add('layerOn')
      } else if (window.innerWidth >= 768) {
        document.body.classList.remove('layerOn')
      }
    },
    goStep (step) {
      this.step = step
      if (step === 2) {
        this.isCreated = true
        this.scrollBottom()
      } else {
        this.scrollTop()
      }
    },
    checkAvailable (day) {
      return this.getAvailableDay(day)
    },
    async getServiceSetting () {
      function weekDay (obj) {
        let arr = [
          { id: 'mon' },
          { id: 'tue' },
          { id: 'wed' },
          { id: 'thu' },
          { id: 'fri' },
          { id: 'sat' },
          { id: 'sun' }
        ]
        arr = obj ? arr.map(x => {
          const weekday = obj[x.id]
          return {
            ...x,
            available: weekday && weekday.time.length > 0 && weekday.service,
            time: weekday && weekday.time
          }
        }) : null
        return arr
      }
      return this.$store.dispatch('talk/getCenterSetting').then((res) => {
        // this.isDisabled = true
        if (res) {
          const today = moment().isoWeekday() - 1
          this.service = {
            active: res.service,
            available: weekDay(res.serviceTime),
            checkInOnly: res.checkInOnly
          }
          this.service.now = this.service.available ? this.checkAvailable(this.service.available[today]) : true
          this.$store.commit('talk/updateSetting', false)
          return res
        } else {
          this.$store.commit('talk/updateSetting', false)
          return false
        }
      })
    },
    getChannel (cid) {
      const data = {
        cid: cid
      }
      return this.$store.dispatch('talk/getChannel', data).then((res) => {
        this.user = {
          ...this.user,
          ...res.userName && {
            userName: res.userName
          },
          ...res.userPhone && {
            userPhone: res.userPhone
          },
          ...res.userEmail && {
            userEmail: res.userEmail
          }
        }
        this.$store.commit('talkChannel', res ? cid : false)
        return res
      })
    },
    readByUser (cid, ids) {
      const data = {
        cid: cid,
        msgIds: ids
      }
      if (ids && ids.length > 0) {
        this.$store.dispatch('talk/readByUser', data)
      }
    },
    getDisconnectMessage (cid) {
      // 로컬에 미전송되었던 메시지들 해당 재전송|삭제 처리
      const disconnectStorage = ls.get(`talkDisconnect_${cid}`)
      if (disconnectStorage) {
        this.card = this.card.concat(disconnectStorage).sort(function (a, b) {
          return a.createat < b.createat ? -1 : a.createat > b.createat ? 1 : 0
        })
      }
    },
    async getMessageList (isBefore) {
      const cid = this.cid
      const data = {
        cid: cid,
        ...this.lastEvaluatedKey && {
          LastEvaluatedKey: this.lastEvaluatedKey
        }
      }
      return this.$store.dispatch('talk/getMessage', data).then((res) => {
        if (res) {
          const ids = res.Items ? res.Items.map(x => x.msgId) : []
          this.setMessageList(res.Items || [], isBefore)
          this.lastEvaluatedKey = res.LastEvaluatedKey || null
          if (ids.length) {
            this.readByUser(cid, ids)
          }
          return res
        } else {
          return false
        }
      })
    },
    setMessageList (arr, isBefore, ws, from) {
      const talkBody = document.getElementById('talkBody')
      const added = arr.filter(x => x.msgId).map(x => {
        return {
          createat: x.createat,
          readByUser: x.readByUser,
          ...x.payload || x,
          ...x.translatedText && {
            translatedText: x.translatedText
          }
        }
      }).map(x => {
        return {
          msgId: x.msgId,
          createat: x.createat,
          msgType: x.type || x.msgType || 'text',
          fromTo: x.from === 'user' ? 'to' : 'from',
          userName: x.userName,
          readByUser: x.readByUser,
          message: x.text || x.fileName,
          ...(x.type === 'video' && x.thumbnail) && {
            thumbnail: x.thumbnail
          },
          ...x.translatedText && {
            translatedText: x.translatedText
          }
        }
      })
      function setArr (arr) {
        const sort = arr.sort(function (a, b) { // sort by createat
          return a.createat < b.createat ? -1 : a.createat > b.createat ? 1 : 0
        })
        const unique = [...new Map(sort.map(item => [item.msgId, item])).values()] // unique key: msgId
        return unique
      }
      this.sending = false
      if (isBefore) {
        this.card = setArr(added.concat(this.card))
      } else {
        this.card = setArr(this.card.concat(added))
        if (ws) {
          /**
           * (ws) 메시지가 도착하고 현재 최하단 스크롤이면 메시지 길이만큼 스크롤 이동
           * 스크롤이 최하단이 아니면 토스트메시지
           */
          if (from === 'user') { // 보낸 메시지
            this.scrollBottom()
          } else {
            if (talkBody && talkBody.scrollHeight === talkBody.scrollTop + talkBody.clientHeight) { // 받은 메시지 + 최하단
              this.scrollBottom()
            } else {
              this.toastMessage()
            }
          }
        } else {
          /**
           * mounted 후 최초 1회
           * 최하단으로 스크롤 이동
           */
          this.scrollBottom()
        }
      }
    },
    // 새로운 메시지가 왔을 때 스크롤이 최하단이 아닌 경우 토스트 메시지
    toastMessage () {
      this.toast = true
    },
    // 메시지 전송
    async postMessage (data) {
      this.disconnect += 1
      this.scrollBottom()
      return this.$store.dispatch('talk/postMessage', data).then((res) => {
        if (res) {
          this.sending = false
          this.sendingImg = false
          this.completePost = true
          this.attachImg = null
          this.disconnect = 0
          this.$store.commit('talkChannel', this.cid)
          return data.msgId
        } else if (this.disconnect <= 3) {
          // 전송or연결실패 3초간 재전송 시도
          setTimeout(() => {
            this.postMessage(data)
          }, 600)
        } else {
          // 전송or연결실패 3초 후 실패메시지 로컬스토리지에 저장
          if (!data.disconnect) {
            // 첨부이미지 또는 비디오
            if (data.data && data.fileName) {
              // 업로드에 실패했습니다. 연결상태를 확인해주세요.
              alert(this.locale.alert_upload_fail)
            } else {
              const disconnectStorage = ls.get(`talkDisconnect_${data.cid}`) || []
              const talkData = [{
                fromTo: 'to',
                message: data.content,
                msgId: data.msgId,
                userName: data.userName,
                disconnect: true,
                disconnectBefore: this.card[this.card.length - 1].msgId,
                createat: moment().toISOString()
              }]
              const talkDisconnect = disconnectStorage.concat(talkData)
              ls.set(`talkDisconnect_${data.cid}`, talkDisconnect)
              this.card = this.card.concat(talkData)
            }
          }
          this.attachImg = null
          this.sendingImg = false
          this.sending = false
          this.completePost = false
          return false
        }
      })
    },
    // 부재중 메시지 처리
    disabledMessage () {
      // 지금은 운영시간이 아닙니다.
      this.content = this.locale.not_available_time
    },
    send () {
      const hasMessage = regExp.replaceAllEmpty(this.content).length > 0
      const hasImg = this.attachImg
      const data = {
        cid: this.cid,
        msgId: UNIQUE.mid(),
        content: this.content,
        userName: this.user.userName
      }
      const imgData = hasImg
        ? {
          cid: this.cid,
          msgId: UNIQUE.mid(),
          fileName: hasImg.name,
          data: hasImg.base64Name,
          type: 'image',
          userName: this.user.userName
        } : null
      const contentInput = this.$refs.contentInput
      this.content = ''
      if (contentInput) {
        contentInput.focus()
        contentInput.removeAttribute('style')
      }
      // 이미지가 있다면 이미지 전송 (type: image)
      if (hasImg) {
        this.sendingImg = true
        this.postMessage(imgData)
      }
      // 메시지가 있다면 메시지 전송 (type: text)
      if (hasMessage) {
        this.sending = true
        this.postMessage(data)
      }
    },
    // 재전송
    async reSend (data) {
      this.sending = true
      await this.postMessage(data).then((msgId) => {
        if (msgId) {
          this.delDisconnect(msgId)
          this.card = this.card.filter(x => !(x.msgId === msgId && x.disconnect))
        }
      })
    },
    // 로컬에 저장된 카드/태그에 관한 정보 대화리스트에 추가
    getResponseMessage (cid) {
      const responseStorage = ls.get(`talkResponse_${cid}`)
      if (responseStorage) {
        this.card = this.card.concat(responseStorage).sort(function (a, b) {
          return a.createat < b.createat ? -1 : a.createat > b.createat ? 1 : 0
        })
      }
    },
    // 제작된 카드 또는 태그 클릭시 답변 데이터
    responseMessage (type, id) {
      const lang = this.lang
      const typeList = `${type}List`
      const responseData = {
        cid: this.cid,
        fromTo: 'from',
        message: null,
        msgId: UNIQUE.mid(),
        msgType: type === 'tag' ? 'text' : 'card',
        userName: 'STAY Bot',
        createat: moment().toISOString()
      }
      if (type === 'tag') {
        const item = this[typeList].find(x => x.id === id)
        if (item.answerType === 'input') {
          responseData.message = item.answer[lang]
        } else if (item.answerType === 'card') {
          const card = this.cardList.find(x => x.id === item.answerCard)
          responseData.message = card.text[lang]
          responseData.linkActive = card.linkActive
          responseData.link = card.link
          responseData.img = card.img
        }
      }
      this.scrollBottom()
      return responseData
    },
    // 카드정보(Q&A), 현재 대화화면인지?(아닌경우 입장하여 진행)
    async getMessageCard (data, isTalking) {
      const cid = this.cid
      const type = `${data.type}List`
      const content = this[type] && this[type].find(x => x.id === data.id) // cardList || tagList
      const contentKey = data.type === 'card' ? 'text' : data.type // card || talk
      const talkData = [{
        cid: cid,
        fromTo: 'to',
        message: `${data.type === 'tag' ? '#' : ''}${content[contentKey][this.lang]}`,
        msgId: UNIQUE.mid(),
        msgType: data.type,
        userName: this.user.userName,
        autoResponse: true,
        beforeMsgId: this.card[this.card.length - 1] ? this.card[this.card.length - 1].msgId : null,
        createat: moment().toISOString()
      }, {
        ...this.responseMessage(data.type, data.id)
      }]
      const responseStorage = ls.get(`talkResponse_${cid}`) || []
      const talkResponse = responseStorage.concat(talkData)
      if (!isTalking) {
        await this.create(true)
      }
      ls.set(`talkResponse_${this.cid}`, talkResponse)
      this.card = this.card.concat(talkData)
    },
    delDisconnect (msgId) {
      const cid = this.cid
      const disconnectStorage = ls.get(`talkDisconnect_${cid}`)
      const filtered = disconnectStorage.filter(x => x.msgId !== msgId)
      ls.set(`talkDisconnect_${cid}`, filtered)
      this.card = this.card.filter(x => !(x.msgId === msgId && x.disconnect))
    },
    talkCreate () {
      if (this.isCreated) {
        this.goStep(2)
      } else {
        this.create()
      }
    },
    // 톡방 생성(post || put)
    async create (fromEnterance) {
      const siteinfo = this.siteinfo
      const ota = siteinfo.k
      const cid = siteinfo.k || localStorage.getItem(`${siteinfo.site}_stayTalk`) || UNIQUE.mid()
      const data = {
        cid: cid,
        ...ota && { ota: ota },
        ...this.user
      }
      return this.$store.dispatch('talk/chatToken', data).then((res) => {
        if (res) { // cid
          if (res.status && res.status === 403) {
            alert(this.locale.alert_system_error)
            return false
          } else {
            const key = `${siteinfo.site}_stayTalk`
            const receivedKey = `talkReceived_${cid}`
            this.$store.commit('talk/setCid', res)
            if (!ota) {
              localStorage.setItem(key, res)
            }
            this.goStep(2)
            this.cid = res
            this.getMessageList().then((res) => {
              // 전송실패 메시지 처리(localStorage)
              this.getDisconnectMessage(cid)
              // 미확인 카운트 처리 (모두 읽음 표시)
              localStorage.setItem(receivedKey, 0)
              this.$store.commit('talk/received', 0)
              // 태그를 통한 자동응답처리 (이미 대문에서 태그를 통해 넘어온 경우 실행하지 않음)
              if (!fromEnterance) {
                this.getResponseMessage(cid)
              }
            })
            return true
          }
        } else {
          alert(this.locale.alert_system_error)
          return false
        }
      })
    },
    // 채널 유저정보
    updateChannel () {
      const cid = this.cid
      const user = this.user
      const userInfo = {
        ...user.userEmail && {
          userEmail: user.userEmail
        },
        ...user.userName && {
          userName: user.userName
        },
        ...user.userPhone && {
          userPhone: user.userPhone
        }
      }
      const data = {
        cid: cid,
        ...userInfo
      }
      if (this._.isEmpty(userInfo)) {
        // alert('정보를 하나 이상 입력해주세요.')
        alert(this.locale.alert_input_information_required)
      } else {
        if (cid) {
          this.$store.dispatch('talk/updateChannel', data).then((res) => {
            if (res) {
              // alert('정보가 저장되었습니다.')
              alert(this.locale.alert_save_information)
            } else {
              alert(this.locale.alert_system_error)
            }
          })
        } else {
          this.create()
        }
      }
    },
    // 토스트메시지 클릭으로 최하단 스크롤 이동
    toastScroll () {
      this.scrollBottom()
      this.toast = false
    },
    setImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0],
        ...getFileInfo(e.target.files[0].type)
      }
      const blobToBase64 = (blob, type) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        return new Promise(resolve => {
          reader.onloadend = () => {
            resolve(reader.result)
          }
        })
      }
      function getFileInfo (typeInfo) {
        const type = typeInfo.split('/')[0]
        const format = typeInfo.split('/')[1]
        // const isValid = regExp[type] && regExp[type].test(format.toLowerCase())
        return {
          type: type,
          format: format
        }
      }
      function getFileSize (size) {
        return size / 1024 / 1024
      }
      if (data.file) {
        if (data.type) {
          if (data.type.includes('image')) {
            this.$store.dispatch('util/setImage', data).then((blob) => {
              if (blob) {
                if (getFileSize(blob.size) > 5) {
                  // 이미지 파일은 최대 5MB까지 업로드 가능합니다.
                  alert(this.locale.alert_upload_image_size)
                } else {
                  const fileName = blob.name
                  blobToBase64(blob).then((res) => {
                    this.attachImg = {
                      id: data.id,
                      base64: res,
                      base64Name: res.split(',')[1],
                      name: fileName
                    }
                  })
                }
              }
            })
          } else {
            alert(`${this.locale.alert_upload_format_not_support}\n${this.locale.alert_upload_image_video_only}`)
          }
        } else {
          // 지원하지 않는 형식의 파일입니다.\n이미지: png, jpeg, gif\n동영상: mp4, ogg, webm
          alert(`${this.locale.alert_upload_format_not_support}\n${this.locale.alert_upload_image_video_only}`)
        }
      } else {
        alert(this.locale.alert_attach_fail)
      }
      e.target.value = ''
    },
    delImg () {
      // 이미지 전송을 취소하시겠습니까?
      if (window.confirm(this.locale.confirm_cancel_image_upload)) {
        this.attachImg = null
      }
    },
    // 최하단으로 스크롤 이동
    scrollBottom () {
      let scrollChecker = setInterval(() => {
        if (document.getElementById('talkBody')) {
          const talkBody = document.getElementById('talkBody')
          talkBody.scrollTop = talkBody.scrollHeight
        }
      }, 100)
      setTimeout(() => {
        clearInterval(scrollChecker)
      }, 500)
    },
    // 최상단으로 스크롤 이동
    scrollTop () {
      let scrollChecker = setInterval(() => {
        if (document.getElementById('enteranceBody')) {
          const talkBody = document.getElementById('enteranceBody')
          talkBody.scrollTop = 0
        }
      }, 100)
      setTimeout(() => {
        clearInterval(scrollChecker)
      }, 500)
    },
    scrollBody (e) {
      const top = e.target.scrollTop
      const talkBody = document.getElementById('talkBody')
      const beforeHeight = talkBody.scrollHeight
      /**
       * 스크롤업 할 때 api 호출과 함께
       * append data의 높이만큼 계산하여
       * 현재 스크롤 위치를 유지
       */
      if (top === 0 && this.lastEvaluatedKey) {
        this.getMessageList(true)
        let scrollChecker = setInterval(() => {
          if (talkBody.scrollTop === 0) {
            talkBody.scrollTop = talkBody.scrollHeight - beforeHeight
          }
        }, 100)
        setTimeout(() => {
          clearInterval(scrollChecker)
        }, 500)
      }
      /**
       * 스크롤이 최하단에 있을 경우 (오차범위 80)
       * 토스트 메시지 삭제
       */
      if (talkBody.scrollTop + talkBody.clientHeight >= talkBody.scrollHeight - 80) {
        this.toast = false
      }
    },
    close () {
      document.body.classList.remove('layerOn')
      document.removeEventListener('visibilitychange', this.backgroundBrowser)
      window.removeEventListener('resize', this.checkDeviceSize)
      this.$store.commit('talk', false)
    },
    updateOnlineStatus (e) {
      const { type } = e
      this.onLine = type === 'online'
    }
  }
}
</script>
